module.exports = "https://cdn.realtymogul.com/static/media/down_expand_white.65c8e6a2.svg";